import { Component, h, Element, Listen } from '@stencil/core';
import { calculateChildTagName } from '../_helpers/prefixes';

@Component({
	tag: 'ds-accordion',
	shadow: false,
})
export class Accordion {
	@Element() el: HTMLDsAccordionElement;

	items: HTMLDsAccordionItemElement[];

	componentDidLoad(): void {
		const accordionItemTagName = calculateChildTagName(
			this.el,
			'ds-accordion-item'
		);
		this.items = Array.from(this.el.firstElementChild.children).filter(
			(item) => item.tagName.toLowerCase() === accordionItemTagName
		) as HTMLDsAccordionItemElement[];
		this.items.forEach((item, index) => (item.index = index));
		if (this.el.getAttribute('collapse-first-accordion') === 'false') {
			this.items[0].expand();
		}
	}

	@Listen('accordionKeydown')
	accordionKeydownHandler(event: CustomEvent) {
		const key = event.detail.originalEvent.key;
		const currentIndex = event.detail.index;

		if (key === 'ArrowDown' && this.items.length > currentIndex + 1) {
			const target = this.items[currentIndex + 1];
			target.focusOnLabel();
		}

		if (key === 'ArrowUp' && currentIndex > 0) {
			const target = this.items[currentIndex - 1];
			target.focusOnLabel();
		}

		if (key === 'Home') {
			event.detail.originalEvent.preventDefault();
			const target = this.items[0];
			target.focusOnLabel();
		}

		if (key === 'End') {
			event.detail.originalEvent.preventDefault();
			const target = this.items[this.items.length - 1];
			target.focusOnLabel();
		}
	}

	render() {
		return (
			<form>
				<slot />
			</form>
		);
	}
}
